import { useLocation } from 'react-router'

import logo from 'Images/logo.png'
import { Col, Row } from 'ui'

const AppSignedIn = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const token = (queryParams.get('key') === 'true')
  return (
    <div className="tw:flex tw:min-h-screen tw:flex-col tw:items-center tw:gap-6 tw:bg-background">
      <Row className="tw:w-full tw:bg-surface" style={{
        paddingInline: '0.625rem',
      }}>
        <div style={{
          alignItems: 'center',
          display: 'flex',
          maxWidth: '1300px',
          marginInline: 'auto',
          minHeight: 'calc(3rem + 2 * 0.875rem)',
          paddingBlock: '0.875rem',
          paddingInline: '1rem',
          width: '100%',
        }}>
          <img alt="ExpanDrive" width="340" height="64" style={{
            color: 'transparent',
            height: 'auto',
            paddingBlock: '0.5rem',
            width: 'clamp(8rem, CALC(7.5rem + 3vw), 10rem)',
          }} src={logo} />
        </div>

      </Row>
      <Row className="tw:flex tw:w-full tw:items-center" style={{ paddingInline: '15px', maxWidth: '1300px' }} noGutters>
        <Col className="tw:mx-auto">
          <input type="hidden" id="jwt_token" value={String(token)} />
          <div style={{ height: 'auto', width: '170px', backgroundImage: 'url(' + logo + ')' }} />
          <div className="tw:auth-separator"><span className="tw:auth-separator-text">Sign-in successful.</span></div>
        </Col>
      </Row>
    </div>
  )
}

export default AppSignedIn
